import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { AdminWithdrawalListResponse } from '../../responses/platform/admin-withdrawal-list.response';

@Injectable({ providedIn: 'root' })
export class AdminWithdrawalService extends CommonService {
  private readonly base = environment.urlApiPlatform + 'AdminWithdrawal/';

  constructor(private http: HttpClient) { super(); }

  // -------- LISTA --------
  postList(): Observable<AdminWithdrawalListResponse> {
    const url = this.base + 'List';
    return this.http
      .get<AdminWithdrawalListResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  // -------- UPLOADS --------
  confirmPayment(idWalletWithdrawal: number, file: File): Observable<ReturnStruct> {
    const url = `${this.base}${idWalletWithdrawal}/confirmPayment`;
    const form = new FormData();

    const options = this.addHeaderToken();
    if (options && options.headers && options.headers.has('Content-Type')) {
      options.headers = options.headers.delete('Content-Type');
    }

    form.append('file', file, file.name);
    return this.http
      .post<ReturnStruct>(url, form, options)
      .pipe(catchError(this.handleError));
  }
}